import React, {useState, useEffect} from 'react';
import HowItWorksContainer from '../container/HowItWorks';
import Footer from '../components/footer';
import '../styles/how-it-works.css'


interface Props{
}
const HowItWorks: React.FC<Props> = ({}) => {

    useEffect(() =>{
      document.title = "How It Works | PuppySpot";
    }, []);

  return (
    <div>
      <HowItWorksContainer />
      <Footer />
    </div>
  );
}

export default HowItWorks;